var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("flex w-full h-full flex-col items-center justify-center lg:flex-row lg:items-start py-24 px-6 lg:px-16 xl:px-40 2xl:px-60 " + _vm.variant)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }